
import CirclesPurpleIcon from '@src/assets/icons/circles-purple.svg';
import { Link } from 'gatsby';
import React from 'react';
import { Box, Button, Container, Grid } from 'theme-ui';
import { Themed } from '@theme-ui/mdx';

const howThisWorkSection = ({ bgColor, showCircles = false, vm }) => {
  return <></>;

  if (!vm) {
    return <></>;
  }

  return (
    <Box className="relative" bg={bgColor} py={5}>
      {showCircles && (
        <CirclesPurpleIcon className="circle-bottom-right circle-purple" />
      )}

      <Container p={4}>
        <Grid columns={[1, 1, 1, 2]} gap="60px" sx={{ alignItems: 'stretch' }}>
          <Box>
            <Themed.h2 sx={{ margin: 0 }}>{vm.title}</Themed.h2>
            <Box sx={{ color: 'grey800' }}>{vm.description}</Box>
            <Box className="how-it-works__image-wrapper" my={4}>
              <iframe
                loading="lazy"
                className="responsive-iframe"
                width="560"
                height="315"
                src={vm.videoUrl}
                title="Video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </Box>
          </Box>
          <Box className="how-it-works__steps">
            <Box className="how-it-works__steps-bg-element">
              <svg viewBox="0 0 40 50">
                <polygon
                  strokeWidth="4px"
                  strokeLinejoin="round"
                  points="2,2 2,48 38,25"
                />
              </svg>
            </Box>

            {vm.steps.map(({ title, description, icon }) => {
              return (
                <Box key={title} className="how-it-works__step">
                  <Box className="how-it-works__step-icon-wrapper">
                    <img src={icon} height="50" width="50" alt="" />
                  </Box>
                  <Box>
                    <Themed.h5 sx={{ margin: '0' }}>{title}</Themed.h5>
                    <Box
                      sx={{
                        color: 'grey600',
                        p: { margin: 0 },
                      }}
                    >
                      {description}
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Grid>

        {vm.buttonLink && (
          <Box
            sx={{
              paddingTop: 6,
              paddingBottom: 4,
              textAlign: 'center',
            }}
          >
            {vm.buttonLink.startsWith('http') && (
              <a href={vm.buttonLink} target="_blank" rel="noreferrer">
                <Button>{vm.buttonText}</Button>
              </a>
            )}
            {!vm.buttonLink.startsWith('http') && (
              <Link to={vm.buttonLink}>
                <Button>{vm.buttonText}</Button>
              </Link>
            )}
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default howThisWorkSection;
